import { makeStyles } from "@material-ui/core/styles";

const AddEditPreshiftPopupStyle = makeStyles({
  customForm: {
    overflow: "hidden",
    "& .form-row": {
      display: "flex",
      margin: "0 -10px",
      "@media (max-width: 575px)": {
        flexWrap: "wrap",
      },
      "& .form-gourp": {
        padding: "0 10px",
        flex: "0 0 100%",
        "& .label-text": {
          fontSize: 14,
        },
        " & .error-text": {
          color: "red",
        },
        " & .MuiTypography-body1": {
          fontSize: 16
        }
      },
    },
  },
  customModal: {
    "& .MuiDialog-paperWidthSm": {
      boxShadow: "0 5px 8px 0 rgba(0, 0, 0, 0.24)",
      padding: "36px 40px 40px",
      maxWidth: 850,
      width: "100%",
      "&.MuiDialog-paperScrollBody": {
        "@media (max-width: 991px)": {
          display: "block",
        },
      },
      "@media (max-width: 991px)": {
        padding: "20px 15px",
        margin: 30,
        maxWidth: "100%",
        width: "auto",
      },
      "@media (max-width: 767px)": {
        margin: "15px",
      },
      "& .MuiDialogTitle-root": {
        padding: "0",
        display: "flex",
        justifyContent: "space-between",
        marginBottom: "30px",
        "@media (max-width: 480px)": {
          marginBottom: "20px",
        },
      },
      "& .MuiDialogContent-root": {
        padding: "0",
        overflow: "hidden",
      },
      "& h2": {
        fontSize: "24px",
        fontWeight: "700",
        lineHeight: "40px",
      },
    },
    "& .close-modal": {
      position: "absolute",
      top: 15,
      right: 20,
      "& img": {
        cursor: "pointer",
      },
    },
    "& .bottom-button-block": {
      padding: "15px 0 0",
      display: "flex",
      justifyContent: "space-between",
      "@media (max-width: 480px)": {
        flexDirection: "column",
      },
      "& button": {
        height: "50px",
        lineHeight: "50px",
        fontWeight: "600",
        fontSize: "16px",
        minWidth: "165px",
        textTransform: "uppercase",
        "@media (max-width: 480px)": {
          minWidth: "100%",
          margin: "0 0 15px",
        },
      },
      "& .MuiCircularProgress-root": {
        verticalAlign: "middle",
      },
    },
  },
});

export { AddEditPreshiftPopupStyle };
